<template>
	<div class="mb-4 flex items-center">
		<component
			:is="feature.icon"
			:icon-color="iconColor"
			:class="['mr-3 h-6 min-w-6', iconColor]"
		/>
		<p
			:class="[
				onDark ? 'text-white' : '',
				'text-[14px]'
			]"
		>
			{{ feature.description }}
		</p>
	</div>
</template>

<script setup>
import { computed, toRefs } from 'vue';

const props = defineProps({
	feature: {
		type: Object,
		default() {
			return {};
		}
	},
	planType: {
		type: String,
		default: ''
	},
	onDark: {
		type: Boolean,
		default: false
	}
});

const { feature, planType, onDark } = toRefs(props);

const iconColor = computed(() => {
	if (onDark.value) {
		return 'text-white';
	}

	return planType.value === 'premium' ? 'text-won-green' : 'text-won-gray';
});
</script>
